
import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { IConfigGroup, IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";
import { allOrganisationConfigGroups } from "./organisation-configuration-page-elements";

@Component({
    selector: "adapt-organisation-configuration",
    templateUrl: "./organisation-configuration-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class OrganisationConfigurationPageComponent extends BaseRoutedComponent implements OnInit {
    public ConfigArea = ConfigArea;
    public configGroups: IConfigGroup[] = [];
    public selectedItem?: IConfigItem;

    public constructor(injector: Injector) {
        super(injector);
    }

    public async ngOnInit() {
        this.configGroups = allOrganisationConfigGroups();
        this.notifyActivated();
    }
}
